import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';

@Component({
  templateUrl: './customers-preview.html',
})
export class CustomersPreviewComponent implements OnInit {
  checked: any;
  date3: any;
  radioValue: any;
  cars1: any; //ANTONIO MAGARI SI VOLEVANO RIFERIRE A CARS ????
  public items: MenuItem[];

  pieData: any;
  lineData: any;

  cities: SelectItem[];
  selectedCity: string;

  cars: any;
  selectedCar: any;

  constructor() {
    this.cities = [];
    this.cities.push({label:'Select City', value:null});
    this.cities.push({label:'New York', value:{id:1, name: 'New York', code: 'NY'}});
    this.cities.push({label:'Rome', value:{id:2, name: 'Rome', code: 'RM'}});
    this.cities.push({label:'London', value:{id:3, name: 'London', code: 'LDN'}});
    this.cities.push({label:'Istanbul', value:{id:4, name: 'Istanbul', code: 'IST'}});
    this.cities.push({label:'Paris', value:{id:5, name: 'Paris', code: 'PRS'}});

    this.cars = [
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 },
      { vin: 1, year: 1, brand: 1, color: 1 }
    ];
  }

  ngOnInit() {

    this.items = [
      {label: 'Basic Info'},
      {label: 'More Info'},
      {label: 'History'},
      {label: 'Cards'},
      {label: 'Group'}
    ];

    this.lineData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'First Dataset',
          data: [65, 59, 80, 81, 66, 75, 82],
          fill: false,
          borderColor: '#fec65c'
        }
      ]
    };

    this.pieData = {
      labels: ['A','B'],
      datasets: [
        {
          data: [270, 90],
          backgroundColor: [
            "#007be5",
            "#20d077"
          ],
          hoverBackgroundColor: [
            "#00448f",
            "#038d4a"
          ]
        }]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-preview.component.ts